import * as React from 'react';

var UitkLayoutItem = function (props) {
    var children = props.children, className = props.className;
    var childrenArray = React.Children.toArray(children);
    if (!childrenArray.length) {
        return null;
    }
    var firstChild = childrenArray[0];
    var decoratedChild = React.cloneElement(firstChild, {
        className: className
    });
    return decoratedChild;
};

export { UitkLayoutItem };
